import {Outlet} from 'react-router-dom';


import {
    FlexiSignInButton,
    PlatformAppShell,
    PlatformFooter,
    PlatformHeader,
    PlatformHeaderNavigationMenu,
    PlatformHeaderToolbar,
    PlatformLoader,
} from '@flexinet/ui-components';


import {Suspense} from "react";
import {signInWithRedirect, signOut} from 'aws-amplify/auth';

const handleSignIn = async () => {
    try {
        await signOut();
    } catch {
        // ignore — no active session
    }
    await signInWithRedirect();
};


export const PublicLayout = () => {

    const menuItems = [] as { title: string, onClick: () => void }[]

    const additionalToolbarItems = [
        <FlexiSignInButton
            onClick={handleSignIn}>Sign in</FlexiSignInButton>,
    ]

    return <PlatformAppShell
        platformHeader={<PlatformHeader
            navigationMenu={<PlatformHeaderNavigationMenu menuItems={menuItems}/>}
            toolbar={<PlatformHeaderToolbar additionalToolbarItems={additionalToolbarItems}/>}/>}
        platformFooter={<PlatformFooter/>}
        header={{height: 80}}
        footer={{height: 100}}
        navbar={{
            width: 0,
            breakpoint: 'sm',
        }}
    >

        <Suspense fallback={<PlatformLoader/>}>
            <Outlet/>
        </Suspense>

    </PlatformAppShell>


};
